<template>
  <Transition
    name="invitation-main"
    appear
  >
    <slot />
  </Transition>
</template>

<style>
.invitation-main-enter-active,
.invitation-main-leave-active {
  transition:
    opacity 220ms ease,
    transform 220ms ease;
}

.invitation-main-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.invitation-main-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

/* @media (prefers-reduced-motion: reduce) {
  .invitation-main-enter-active,
  .invitation-main-leave-active {
    transition: none !important;
  }
} */
</style>
